// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nE1t","top":"styles_top__3USfd"};